import Button from 'components/button';

const AdditionalInfoSection = ({ dataCreateMission, setPage }) => (
  <div className="mx-6 border-b border-gray-200 py-2">
    <div className="flex justify-between">
      <span className="ft-b text-gray-900 font-medium">
        Informations supplémentaires
      </span>
      <Button color="DEFAULT" size="SM" onClick={() => setPage(1)}>
        Modifier
      </Button>
    </div>
    <div className="flex flex-col gap-4">
      <div className="flex flex-col ft-sm">
        <span className="text-gray-900 font-medium">
          Informations pour le candidat sélectionné :
        </span>
        <p>{dataCreateMission.other || 'Aucune information'}</p>
      </div>
      <div className="flex flex-col ft-sm">
        <span className="text-gray-900 font-medium">
          Informations pour l'agence :
        </span>
        <p>{dataCreateMission.other_interim || 'Aucune information'}</p>
      </div>
    </div>
  </div>
);

export default AdditionalInfoSection;
